module.exports = __webpack_public_path__ + "static/btn_02.c379ad99.png";